<template>
    <div class="submenu-container" :class="customClass">
        <div class="menu-item search" v-if="parent.search">
            <label for="map-search">
                <select class="search-input" id="map-search">
                    <option value="" disabled selected></option>
                </select>
            </label>
        </div>
        <ul>
            <li
                is="submenu-item"
                v-for="(item, index) in items"
                :item="item"
                :key="index"
                :parent="parent"
                :index="index"
                :param-name="paramName"
            ></li>
        </ul>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import inlineSvg from "./inlineSvg.js";
import SubmenuItem from "./SubmenuItem.vue";

export default {
    name: "SubMenu",
    components: {
        inlineSvg,
        "submenu-item": SubmenuItem
    },
    props: {
        items: {
            default: () => {}
        },
        parent: {
            default: () => {}
        },
        customClass: {
            default: ""
        },
        paramName: {
            type: String,
            default: "categories"
        },
        active: {
            default: false
        }
    },
    data() {
        return {
            select2Instance: null,
            results: null
        };
    },
    mounted() {
        const vm = this;
        if ($(".search-input").length && this.parent.search) {
            this.select2Instance = $("#map-search")
                .select2({
                    ajax: {
                        headers: {
                            Authorization: `Bearer ${process.env.MIX_API_KEY}`,
                            "Content-Type": "application/json"
                        },
                        url: `${this.url}/${this.parent.urlKey}`,
                        data: function(params) {
                            return {
                                q: params.term
                            };
                        },
                        processResults: function(data) {
                            vm.results = data;
                            return {
                                results: data.map(el => ({
                                    id: el.id,
                                    text: el.name
                                }))
                            };
                        }
                    },
                    dropdownParent: $("#map-search").parent("label"),
                    placeholder: this.trans.get("map.search_placeholder"),
                    minimumInputLength: 3,
                    allowClear: true,
                    language: {
                        inputTooShort: () =>
                            vm.trans.get("map.search_characters"),
                        noResults: () => vm.trans.get("map.search_no_results"),
                        searching: () => vm.trans.get("map.searching")
                    }
                })
                .on("select2:select", function(e) {
                    let payload = {
                        category: "searchResult",
                        data: vm.results.filter(
                            el => el.id === e.params.data.id
                        )
                    };
                    vm.$store.commit("setMarkers", payload);
                })
                .on("select2:clear", function(e) {
                    let payload = {
                        category: "searchResult",
                        data: []
                    };
                    vm.$store.commit("removeMarkers", payload);
                })
                .on("select2:open", function(e) {
                    $(
                        "#map-search ~ .select2-container .select2-search__field"
                    ).focusout(function(e) {
                        $(
                            "#map-search ~ .select2-container .select2-search__field"
                        ).focus();
                    });
                    const evt = "scroll.select2";
                    $(e.target)
                        .parents()
                        .off(evt);
                    $(window).off(evt);
                });
        }
    },
    computed: {
        ...mapGetters(["url", "markers"])
    },
    watch: {
        markers(newValue) {
            if (
                (Object.keys(newValue) && !Object.keys(newValue).length) ||
                (Object.keys(newValue) &&
                    Object.keys(newValue).length &&
                    !Object.keys(newValue).find(key => key === "searchResult"))
            ) {
                if (
                    this.select2Instance &&
                    this.results &&
                    this.results.length
                ) {
                    this.select2Instance.val(null).trigger("change");
                }
            }
        }
    }
};
</script>
